
export const name = "case-study-editor-ui";
export const version = "dev";
